import React, { useState } from 'react';
import { User2Icon, CreditCardIcon, BellIcon, ShieldIcon, KeyIcon, UserIcon, SmileIcon, CatIcon, DogIcon, BirdIcon, ChevronRightIcon, BarChart3Icon, ClockIcon, StarIcon, BoxIcon, AwardIcon, ZapIcon, BrainIcon } from 'lucide-react';
import { mockApps } from '../utils/mockData';
import { useNavigate } from 'react-router-dom';
const avatarOptions = [{
  icon: <UserIcon className="h-6 w-6" data-id="element-1613" />,
  name: 'Default'
}, {
  icon: <SmileIcon className="h-6 w-6" data-id="element-1614" />,
  name: 'Smile'
}, {
  icon: <CatIcon className="h-6 w-6" data-id="element-1615" />,
  name: 'Cat'
}, {
  icon: <DogIcon className="h-6 w-6" data-id="element-1616" />,
  name: 'Dog'
}, {
  icon: <BirdIcon className="h-6 w-6" data-id="element-1617" />,
  name: 'Bird'
}];
const subscriptionTiers = [{
  name: 'Free',
  price: '$0',
  current: true,
  features: ['10 Created AI Apps', '2,000 Monthly Credits', 'Basic Support', 'Community Access']
}, {
  name: 'Pro',
  price: '$9.99/mo',
  current: false,
  features: ['Unlimited Created Apps', '50,000 Monthly Credits', 'Priority Support', 'API Access', 'No Ads']
}, {
  name: 'Enterprise',
  price: 'Custom',
  current: false,
  features: ['Custom AI Models', 'Unlimited Credits', 'Dedicated Support', 'Team Management', 'Custom Integration']
}];
export const MyAccount = () => {
  const navigate = useNavigate();
  const [selectedAvatar, setSelectedAvatar] = useState(0);
  // Calculate mock statistics
  const totalApps = mockApps.length;
  const totalUsage = '234'; // This would come from real usage data
  const avgRating = 4.8;
  const StatCard = ({
    icon: Icon,
    label,
    value
  }: any) => <div className="bg-white p-6 rounded-lg border border-gray-200" data-id="element-1618">
      <div className="flex items-center justify-between mb-4" data-id="element-1619">
        <div className="text-gray-500" data-id="element-1620">{label}</div>
        <Icon className="h-5 w-5 text-gray-400" data-id="element-1621" />
      </div>
      <div className="text-2xl font-semibold" data-id="element-1622">{value}</div>
    </div>;
  return <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8" data-id="element-1623">
      <div className="max-w-4xl mx-auto space-y-8" data-id="element-1624">
        {/* Badges Section */}
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-1625">
          <div className="px-6 py-8" data-id="element-1626">
            <h2 className="text-2xl font-bold mb-6" data-id="element-1627">My Badges</h2>
            <div className="flex flex-wrap gap-4" data-id="element-1628">
              <div className="flex items-center space-x-3 bg-indigo-50 border border-indigo-200 rounded-full px-4 py-2" data-id="element-1629">
                <AwardIcon className="h-5 w-5 text-indigo-600" data-id="element-1630" />
                <span className="text-indigo-700 font-medium" data-id="element-1631">Developer</span>
              </div>
              <div className="flex items-center space-x-3 bg-purple-50 border border-purple-200 rounded-full px-4 py-2" data-id="element-1632">
                <ZapIcon className="h-5 w-5 text-purple-600" data-id="element-1633" />
                <span className="text-purple-700 font-medium" data-id="element-1634">
                  Early Adopter
                </span>
              </div>
              <div className="flex items-center space-x-3 bg-green-50 border border-green-200 rounded-full px-4 py-2" data-id="element-1635">
                <BrainIcon className="h-5 w-5 text-green-600" data-id="element-1636" />
                <span className="text-green-700 font-medium" data-id="element-1637">Super Nerd</span>
              </div>
            </div>
          </div>
        </div>
        {/* Credits Usage Section */}
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-1638">
          <div className="px-6 py-8" data-id="element-1639">
            <h2 className="text-2xl font-bold mb-6" data-id="element-1640">Credits</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1641">
              <div className="p-6 border border-gray-200 rounded-lg" data-id="element-1642">
                <div className="flex justify-between items-center mb-4" data-id="element-1643">
                  <span className="text-gray-600" data-id="element-1644">Available Credits</span>
                  <ZapIcon className="h-5 w-5 text-amber-500" data-id="element-1645" />
                </div>
                <div className="text-3xl font-bold" data-id="element-1646">1,459</div>
                <div className="text-sm text-gray-500 mt-2" data-id="element-1647">
                  Resets in 12 days
                </div>
              </div>
              <div className="p-6 border border-gray-200 rounded-lg" data-id="element-1648">
                <div className="flex justify-between items-center mb-4" data-id="element-1649">
                  <span className="text-gray-600" data-id="element-1650">Used This Month</span>
                  <BarChart3Icon className="h-5 w-5 text-indigo-500" data-id="element-1651" />
                </div>
                <div className="text-3xl font-bold" data-id="element-1652">541</div>
                <div className="text-sm text-gray-500 mt-2" data-id="element-1653">
                  of 2,000 monthly credits
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Profile Section */}
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-1654">
          <div className="px-6 py-8" data-id="element-1655">
            <h2 className="text-2xl font-bold mb-6" data-id="element-1656">My Profile</h2>
            <div className="flex flex-col sm:flex-row items-start gap-8" data-id="element-1657">
              <div className="w-full sm:w-64" data-id="element-1658">
                <div className="mb-4" data-id="element-1659">
                  <div className={`w-32 h-32 rounded-full bg-indigo-100 flex items-center justify-center mb-4`} data-id="element-1660">
                    {avatarOptions[selectedAvatar].icon}
                  </div>
                  <button className="text-sm text-indigo-600 hover:text-indigo-700" data-id="element-1661">
                    Change Avatar
                  </button>
                </div>
                <div className="grid grid-cols-5 gap-2" data-id="element-1662">
                  {avatarOptions.map((option, index) => <button key={index} className={`p-2 rounded-lg border ${selectedAvatar === index ? 'border-indigo-600 bg-indigo-50' : 'border-gray-200 hover:border-indigo-600'}`} onClick={() => setSelectedAvatar(index)} data-id="element-1663">
                      {option.icon}
                    </button>)}
                </div>
              </div>
              <div className="flex-1 w-full" data-id="element-1664">
                <div className="space-y-4" data-id="element-1665">
                  <div data-id="element-1666">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1667">
                      Display Name
                    </label>
                    <input type="text" defaultValue="John Doe" className="w-full border-gray-200 rounded-md px-4 py-2" data-id="element-1668" />
                  </div>
                  <div data-id="element-1669">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1670">
                      Email
                    </label>
                    <input type="email" defaultValue="john@example.com" className="w-full border-gray-200 rounded-md px-4 py-2" data-id="element-1671" />
                  </div>
                  <div data-id="element-1672">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1673">
                      Bio
                    </label>
                    <textarea className="w-full border-gray-200 rounded-md px-4 py-2" rows={3} defaultValue="AI enthusiast and developer" data-id="element-1674" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Dashboard Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1675">
          <StatCard icon={BoxIcon} label="Total Apps" value={totalApps} data-id="element-1676" />
          <StatCard icon={ClockIcon} label="Total Usage" value={`${totalUsage}h`} data-id="element-1677" />
          <StatCard icon={StarIcon} label="Avg. Rating" value={avgRating} data-id="element-1678" />
        </div>
        {/* Subscription Section */}
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-1679">
          <div className="px-6 py-8" data-id="element-1680">
            <h2 className="text-2xl font-bold mb-6" data-id="element-1681">Subscription</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1682">
              {subscriptionTiers.map(tier => <div key={tier.name} className={`rounded-lg border ${tier.current ? 'border-indigo-600 bg-indigo-50' : 'border-gray-200'} p-6`} data-id="element-1683">
                  <h3 className="text-lg font-semibold mb-2" data-id="element-1684">{tier.name}</h3>
                  <p className="text-2xl font-bold mb-4" data-id="element-1685">{tier.price}</p>
                  <ul className="space-y-2 mb-6" data-id="element-1686">
                    {tier.features.map(feature => <li key={feature} className="flex items-center text-sm" data-id="element-1687">
                        <ChevronRightIcon className="h-4 w-4 text-indigo-600 mr-2" data-id="element-1688" />
                        {feature}
                      </li>)}
                  </ul>
                  <button className={`w-full py-2 rounded-md ${tier.current ? 'bg-indigo-600 text-white' : 'border border-indigo-600 text-indigo-600'}`} data-id="element-1689">
                    {tier.current ? 'Current Plan' : 'Upgrade'}
                  </button>
                </div>)}
            </div>
          </div>
        </div>
        {/* Settings Section */}
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-1690">
          <div className="px-6 py-8" data-id="element-1691">
            <h2 className="text-2xl font-bold mb-6" data-id="element-1692">Settings</h2>
            <div className="space-y-4" data-id="element-1693">
              <button onClick={() => navigate('/settings')} className="w-full flex items-center justify-between p-4 rounded-lg border border-gray-200 hover:border-indigo-600 group" data-id="element-1694">
                <div className="flex items-center" data-id="element-1695">
                  <BellIcon className="h-5 w-5 text-gray-400 group-hover:text-indigo-600 mr-3" data-id="element-1696" />
                  <span data-id="element-1697">Notifications</span>
                </div>
                <ChevronRightIcon className="h-5 w-5 text-gray-400" data-id="element-1698" />
              </button>
              <button onClick={() => navigate('/settings')} className="w-full flex items-center justify-between p-4 rounded-lg border border-gray-200 hover:border-indigo-600 group" data-id="element-1699">
                <div className="flex items-center" data-id="element-1700">
                  <ShieldIcon className="h-5 w-5 text-gray-400 group-hover:text-indigo-600 mr-3" data-id="element-1701" />
                  <span data-id="element-1702">Privacy</span>
                </div>
                <ChevronRightIcon className="h-5 w-5 text-gray-400" data-id="element-1703" />
              </button>
              <button onClick={() => navigate('/settings')} className="w-full flex items-center justify-between p-4 rounded-lg border border-gray-200 hover:border-indigo-600 group" data-id="element-1704">
                <div className="flex items-center" data-id="element-1705">
                  <KeyIcon className="h-5 w-5 text-gray-400 group-hover:text-indigo-600 mr-3" data-id="element-1706" />
                  <span data-id="element-1707">Security</span>
                </div>
                <ChevronRightIcon className="h-5 w-5 text-gray-400" data-id="element-1708" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
};